const mutations = {
  SET_ACCESSIBLE_CLIENTS(state, clients) {
    state.accessibleClients = clients;
  },
  SET_LOADING(state, val) {
    state.loading = val;
  },
};

export default mutations;
